var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrazilValidation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7031_17369)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0L0 8.17391L11 16.3478L22 8.17391L11 0ZM11 12.9132C8.43836 12.9132 6.36173 10.7914 6.36173 8.17391C6.36173 5.55647 8.43836 3.43461 11 3.43461C13.5616 3.43461 15.6383 5.55647 15.6383 8.17391C15.6383 10.7914 13.5616 12.9132 11 12.9132Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75728 6.25805C7.27526 6.18107 7.80736 6.14258 8.34889 6.14258C11.1083 6.14258 13.6323 7.1578 15.5912 8.83701C15.5582 9.09683 15.5017 9.34702 15.4264 9.5876C13.5522 7.86509 11.0706 6.81619 8.34889 6.81619C7.7226 6.81619 7.10574 6.87392 6.50771 6.97978C6.57363 6.72958 6.65839 6.489 6.75728 6.25805Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0351 6.70709C7.10102 6.69746 7.1434 6.6301 7.13399 6.55312C7.12457 6.47614 7.06335 6.4184 7.00214 6.42802C6.94092 6.43764 6.89383 6.505 6.90325 6.58199C6.91267 6.65897 6.96917 6.7119 7.0351 6.70709ZM7.04452 6.78888C7.15282 6.77445 7.23287 6.66378 7.21404 6.53868C7.19991 6.41359 7.10102 6.32698 6.98801 6.34141C6.87971 6.35585 6.80436 6.46651 6.81849 6.59161C6.83733 6.7119 6.93621 6.80332 7.04452 6.78888Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46831 6.49038L7.63783 6.48075C7.6708 6.47594 7.69434 6.45189 7.68963 6.4182C7.68963 6.38452 7.66138 6.36047 7.62842 6.36528L7.4589 6.37971L7.46831 6.49038ZM7.40239 6.7502H7.48244L7.47302 6.57698L7.64725 6.56255C7.7226 6.55774 7.78381 6.49038 7.77439 6.41339C7.76968 6.33641 7.70376 6.27867 7.62842 6.28348L7.37885 6.30273L7.40239 6.7502Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77911 6.72117C7.7744 6.65862 7.76498 6.51427 7.6708 6.5239L7.54837 6.53352C7.68493 6.5239 7.69435 6.66343 7.70376 6.73079L7.77911 6.72117Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04281 6.62439H8.16054C8.22646 6.62439 8.27826 6.56665 8.27826 6.49929V6.4608C8.27826 6.39344 8.22175 6.34051 8.15583 6.34051H8.0334L8.04281 6.62439ZM7.96276 6.711H8.16995C8.27355 6.70137 8.35831 6.61477 8.35831 6.50891V6.44637C8.35831 6.34051 8.26884 6.25391 8.16525 6.25391H7.95805L7.96276 6.711Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52312 6.70618L8.92337 6.72062V6.63882L8.60317 6.62439L8.60788 6.50891L8.85745 6.51854L8.86216 6.44155L8.60788 6.43193L8.61259 6.34051L8.91396 6.35495L8.91867 6.26834L8.54195 6.25391L8.52312 6.70618Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08348 6.73067L9.15882 6.74029L9.18708 6.42755L9.24829 6.74511L9.31893 6.75473L9.43194 6.45161L9.40369 6.75954L9.47903 6.76435L9.52141 6.31688L9.40839 6.30726L9.29538 6.60557L9.23417 6.29283L9.12586 6.2832L9.08348 6.73067Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0017 6.83685L10.3266 6.89459L10.3407 6.81761L10.0865 6.7743L10.1053 6.67326L10.3078 6.70694L10.3219 6.63477L10.1194 6.59628L10.1288 6.52411L10.3737 6.56741L10.3878 6.49043L10.0676 6.4375L10.0017 6.83685Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9812 6.78383L11.146 6.82713C11.1742 6.83194 11.2072 6.81751 11.2166 6.78383C11.2213 6.75496 11.2072 6.72128 11.1742 6.71166L11.0094 6.66835L10.9812 6.78383ZM10.8399 7.00516L10.92 7.0244L10.9623 6.86081L11.1319 6.90411C11.2072 6.92336 11.2825 6.88006 11.3014 6.80307C11.3202 6.72609 11.2778 6.64911 11.2025 6.62986L10.9576 6.5625L10.8399 7.00516Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5321 6.93827L11.6922 6.99119C11.7205 7.00082 11.7534 6.98638 11.7628 6.9527C11.7723 6.92383 11.7581 6.89015 11.7252 6.88053L11.5651 6.8276L11.5321 6.93827ZM11.3814 7.15478L11.4615 7.17884L11.5133 7.02006L11.6828 7.07299C11.7534 7.09705 11.8335 7.05374 11.857 6.98157C11.8806 6.9094 11.8382 6.8276 11.7676 6.80355L11.5274 6.72656L11.3814 7.15478Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7393 7.26854C11.7581 7.20599 11.8005 7.07127 11.711 7.0424L11.598 7.00391C11.7299 7.04721 11.6875 7.18193 11.6687 7.24448L11.7393 7.26854Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1301 7.32263C12.1914 7.34668 12.262 7.30338 12.2855 7.23121C12.3138 7.15903 12.2855 7.07724 12.2243 7.05799C12.1631 7.03394 12.0925 7.07724 12.0689 7.14941C12.0407 7.22158 12.0689 7.29857 12.1301 7.32263ZM12.1019 7.39961C12.2055 7.4381 12.3232 7.37555 12.3656 7.26008C12.408 7.1446 12.3609 7.01469 12.2573 6.9762C12.1537 6.93771 12.036 7.00026 11.9936 7.11573C11.9512 7.23602 11.9936 7.36112 12.1019 7.39961Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6528 7.53937C12.714 7.56342 12.7847 7.52974 12.8176 7.45757L12.893 7.49125C12.8459 7.60673 12.7235 7.65965 12.6246 7.61635C12.521 7.57305 12.4786 7.44314 12.5304 7.32766C12.5775 7.21219 12.6999 7.15445 12.7988 7.20256C12.8789 7.23624 12.9212 7.32285 12.9118 7.41427L12.8318 7.37578C12.8271 7.33247 12.8035 7.29398 12.7658 7.27955C12.7093 7.25068 12.634 7.28917 12.6057 7.36134C12.5728 7.43351 12.5916 7.5105 12.6528 7.53937Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7376 7.42383L12.893 7.49119L12.8647 7.54893L12.714 7.48157L12.7376 7.42383Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8318 7.46094L12.893 7.48981L12.8035 7.6967L12.7423 7.66783L12.8318 7.46094Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1331 7.57694L13.2838 7.65392C13.3121 7.66836 13.345 7.65873 13.3592 7.62987C13.3733 7.601 13.3592 7.56732 13.3309 7.55288L13.1802 7.4759L13.1331 7.57694ZM12.9495 7.76459L13.0248 7.80308L13.0955 7.65392L13.2509 7.73572C13.3215 7.7694 13.4015 7.74053 13.4392 7.67317C13.4722 7.601 13.4392 7.5192 13.378 7.48071L13.152 7.36523L12.9495 7.76459Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2885 7.93727C13.3168 7.87953 13.378 7.75443 13.2885 7.71113L13.1802 7.6582C13.3027 7.72075 13.2414 7.85066 13.2132 7.90359L13.2838 7.93727H13.2885Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4533 8.0245L13.7971 8.22658L13.8395 8.15441L13.5569 7.99081L13.6134 7.88977L13.8348 8.01487L13.8677 7.94751L13.6511 7.82241L13.6935 7.74543L13.9572 7.89459L13.9996 7.82241L13.6699 7.63477L13.4533 8.0245Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0985 8.24527C14.0749 8.28376 14.0985 8.32706 14.1503 8.36074C14.2021 8.39442 14.2397 8.39442 14.2538 8.37037C14.3009 8.29338 14.0231 8.17791 14.1079 8.04319C14.1832 7.92771 14.3104 8.01913 14.3574 8.048C14.4045 8.07687 14.4799 8.15866 14.4234 8.25008L14.3433 8.19715C14.3669 8.15385 14.3433 8.11536 14.2962 8.0913C14.2491 8.06724 14.2209 8.05281 14.1973 8.0913C14.155 8.15385 14.4281 8.27414 14.348 8.40886C14.2868 8.5099 14.1785 8.4666 14.1032 8.41848C14.0419 8.37999 13.9525 8.28376 14.009 8.18753L14.0985 8.24527Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5693 8.56826C14.5458 8.60675 14.5693 8.65006 14.6164 8.68374C14.6682 8.72223 14.7059 8.72223 14.72 8.69817C14.7718 8.62119 14.4987 8.49609 14.5929 8.36618C14.6729 8.25551 14.7954 8.35174 14.8425 8.38542C14.8896 8.4191 14.9602 8.50571 14.899 8.59232L14.8189 8.53458C14.8472 8.49609 14.8189 8.4576 14.7812 8.42392C14.7436 8.39505 14.7106 8.38061 14.6824 8.4191C14.6353 8.47684 14.9037 8.61156 14.8142 8.74147C14.7483 8.8377 14.64 8.78959 14.5741 8.73666C14.5128 8.69336 14.4281 8.59232 14.494 8.5009L14.5693 8.56826Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0685 9.02115C15.1203 9.05965 15.2003 9.04521 15.2474 8.98266C15.2945 8.92011 15.2945 8.83832 15.2474 8.79983C15.2003 8.75652 15.1156 8.77577 15.0732 8.83832C15.0214 8.89606 15.0214 8.98266 15.0732 9.02115H15.0685ZM15.0167 9.08851C15.1015 9.16069 15.2333 9.13663 15.3087 9.0404C15.384 8.94417 15.3746 8.80945 15.2898 8.73728C15.2051 8.6651 15.0732 8.68916 14.9979 8.78539C14.9225 8.88162 14.9319 9.01634 15.0167 9.08851Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21405 7.12109L7.15283 7.31355L7.24701 7.34723L7.21405 7.12109Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21404 7.12109L7.27525 7.31355L7.18108 7.34723L7.21404 7.12109Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40239 7.25977H7.20462V7.36081L7.40239 7.25977Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40239 7.25977L7.24229 7.38005L7.18108 7.29826L7.40239 7.25977Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02568 7.25977L7.18578 7.38005L7.24229 7.29826L7.02568 7.25977Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02568 7.25977H7.22345V7.36081L7.02568 7.25977Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33177 7.48543L7.27055 7.29297L7.17638 7.32665L7.33177 7.48543Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33176 7.48528L7.17166 7.36981L7.22817 7.2832L7.33176 7.48528Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09631 7.48528L7.25642 7.36981L7.19991 7.2832L7.09631 7.48528Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09631 7.48543L7.15753 7.29297L7.25171 7.32665L7.09631 7.48543Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62372 9.11133L7.5625 9.30379L7.65668 9.33747L7.62372 9.11133Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62372 9.11133L7.68494 9.30379L7.59076 9.33747L7.62372 9.11133Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81208 9.25195H7.6143V9.35299L7.81208 9.25195Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81207 9.25195L7.65197 9.37224L7.59546 9.29044L7.81207 9.25195Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43536 9.25195L7.59547 9.37224L7.65668 9.29044L7.43536 9.25195Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43536 9.25195H7.63314V9.35299L7.43536 9.25195Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74144 9.47762L7.68022 9.28516L7.58604 9.31884L7.74144 9.47762Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74143 9.47747L7.58133 9.362L7.63784 9.27539L7.74143 9.47747Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.506 9.47747L7.6661 9.362L7.60959 9.27539L7.506 9.47747Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.506 9.47762L7.56721 9.28516L7.66139 9.31884L7.506 9.47762Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05394 9.57422L7.00685 9.733L7.08219 9.75706L7.05394 9.57422Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05394 9.57422L7.10574 9.733L7.0304 9.75706L7.05394 9.57422Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21404 9.68945H7.04922V9.77125L7.21404 9.68945Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21404 9.68945L7.07748 9.78568L7.0304 9.71832L7.21404 9.68945Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89854 9.68945L7.0351 9.78568L7.08219 9.71832L6.89854 9.68945Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89854 9.68945H7.06336V9.77125L6.89854 9.68945Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15283 9.87648L7.10103 9.71289L7.02098 9.74176L7.15283 9.87648Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15283 9.87739L7.02098 9.77634L7.06807 9.70898L7.15283 9.87739Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95976 9.87739L7.09161 9.77634L7.04452 9.70898L6.95976 9.87739Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95976 9.87648L7.01156 9.71289L7.0869 9.74176L6.95976 9.87648Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08048 8.92969L8.04752 9.02111L8.09461 9.03554L8.08048 8.92969Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08048 8.92969L8.10873 9.02111L8.06165 9.03554L8.08048 8.92969Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16995 8.99609H8.07578V9.04421L8.16995 8.99609Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16994 8.99609L8.08989 9.05383L8.06635 9.01534L8.16994 8.99609Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9863 8.99609L8.06635 9.05383L8.0946 9.01534L7.9863 8.99609Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9863 8.99609H8.08519V9.04421L7.9863 8.99609Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13228 9.10314L8.10402 9.01172L8.06165 9.02615L8.13228 9.10314Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13227 9.10209L8.05693 9.04435L8.08518 9.00586L8.13227 9.10209Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02397 9.10209L8.09931 9.04435L8.07106 9.00586L8.02397 9.10209Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02397 9.10314L8.05222 9.01172L8.0946 9.02615L8.02397 9.10314Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58904 9.61719L8.53725 9.77597L8.6173 9.80483L8.58904 9.61719Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58904 9.61719L8.64084 9.77597L8.56079 9.80483L8.58904 9.61719Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74914 9.73242H8.57962V9.81903L8.74914 9.73242Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74914 9.73242L8.61258 9.83346L8.56549 9.7661L8.74914 9.73242Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43365 9.73242L8.5655 9.83346L8.61259 9.7661L8.43365 9.73242Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43365 9.73242H8.59847V9.81903L8.43365 9.73242Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68793 9.92531L8.63613 9.76172L8.55608 9.78578L8.68793 9.92531Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68793 9.92621L8.55138 9.82517L8.60317 9.75781L8.68793 9.92621Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49486 9.92621L8.62671 9.82517L8.57962 9.75781L8.49486 9.92621Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49486 9.92531L8.54195 9.76172L8.622 9.78578L8.49486 9.92531Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45248 10.123L8.4101 10.253L8.47131 10.2722L8.45248 10.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45248 10.123L8.49016 10.253L8.42894 10.2722L8.45248 10.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57492 10.2148H8.44307V10.2822L8.57492 10.2148Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57492 10.2148L8.47132 10.2966L8.42894 10.2389L8.57492 10.2148Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32535 10.2148L8.43365 10.2966L8.47132 10.2389L8.32535 10.2148Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32535 10.2148H8.4572V10.2822L8.32535 10.2148Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52782 10.3682L8.48544 10.2383L8.42422 10.2575L8.52782 10.3682Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52783 10.3671L8.41953 10.2853L8.46191 10.2324L8.52783 10.3671Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37244 10.3671L8.48074 10.2853L8.43836 10.2324L8.37244 10.3671Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37244 10.3682L8.41482 10.2383L8.47603 10.2575L8.37244 10.3682Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4409 6.5L12.3797 6.69246L12.4739 6.72614L12.4409 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4409 6.5L12.4974 6.69246L12.4033 6.72614L12.4409 6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6293 6.64453H12.4268V6.74557L12.6293 6.64453Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6293 6.64453L12.4645 6.76001L12.408 6.67821L12.6293 6.64453Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2479 6.64453L12.4127 6.76001L12.4692 6.67821L12.2479 6.64453Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2479 6.64453H12.4503V6.74557L12.2479 6.64453Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5539 6.87019L12.4927 6.67773L12.3985 6.7066L12.5539 6.87019Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5539 6.87005L12.3938 6.74976L12.455 6.66797L12.5539 6.87005Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3232 6.87005L12.4833 6.74976L12.4221 6.66797L12.3232 6.87005Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3232 6.87019L12.3844 6.67773L12.4786 6.7066L12.3232 6.87019Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2491 9.63672L14.1879 9.82918L14.2821 9.85805L14.2491 9.63672Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2491 9.63672L14.3104 9.82918L14.2162 9.85805L14.2491 9.63672Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 9.77539H14.2397V9.87643L14.4375 9.77539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 9.77539L14.2774 9.89087L14.2209 9.81388L14.4375 9.77539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0608 9.77539L14.2209 9.89087L14.2774 9.81388L14.0608 9.77539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0608 9.77539H14.2586V9.87643L14.0608 9.77539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3669 10.003L14.3056 9.81055L14.2115 9.83942L14.3669 10.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3669 10.0029L14.2068 9.88258L14.2633 9.80078L14.3669 10.0029Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1314 10.0029L14.2915 9.88258L14.235 9.80078L14.1314 10.0029Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1314 10.003L14.1926 9.81055L14.2868 9.83942L14.1314 10.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8943 9.74805L14.8519 9.87796L14.9131 9.8972L14.8943 9.74805Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8943 9.74805L14.9319 9.87796L14.8707 9.8972L14.8943 9.74805Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0167 9.83789H14.8848V9.90525L15.0167 9.83789Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0167 9.83789L14.9131 9.91969L14.8707 9.86676L15.0167 9.83789Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7671 9.83789L14.8754 9.91969L14.9131 9.86676L14.7671 9.83789Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7671 9.83789H14.899V9.90525L14.7671 9.83789Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9696 9.99319L14.9319 9.86328L14.866 9.88253L14.9696 9.99319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9696 9.99214L14.866 9.91035L14.9037 9.85742L14.9696 9.99214Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8142 9.99214L14.9225 9.91035L14.8848 9.85742L14.8142 9.99214Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8142 9.99319L14.8566 9.86328L14.9178 9.88253L14.8142 9.99319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 10.0898L14.3857 10.2486L14.4657 10.2775L14.4375 10.0898Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 10.0898L14.4893 10.2486L14.4092 10.2775L14.4375 10.0898Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5976 10.2051H14.4281V10.2869L14.5976 10.2051Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5976 10.2051L14.461 10.3061L14.414 10.2339L14.5976 10.2051Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2821 10.2051L14.414 10.3061L14.4658 10.2339L14.2821 10.2051Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2821 10.2051H14.4469V10.2869L14.2821 10.2051Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5364 10.3912L14.4846 10.2324L14.4045 10.2565L14.5364 10.3912Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5364 10.3911L14.4045 10.2948L14.4516 10.2227L14.5364 10.3911Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3433 10.3911L14.4752 10.2948L14.4281 10.2227L14.3433 10.3911Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3433 10.3912L14.3951 10.2324L14.4705 10.2565L14.3433 10.3912Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3215 11.0801L13.2697 11.2389L13.3497 11.2677L13.3215 11.0801Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3215 11.0801L13.3733 11.2389L13.2932 11.2677L13.3215 11.0801Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4816 11.1953H13.3121V11.2819L13.4816 11.1953Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4816 11.1953L13.345 11.2964L13.2979 11.229L13.4816 11.1953Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1661 11.1953L13.2979 11.2964L13.345 11.229L13.1661 11.1953Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1661 11.1953H13.3309V11.2819L13.1661 11.1953Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4204 11.3882L13.3686 11.2246L13.2885 11.2535L13.4204 11.3882Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4204 11.3872L13.2838 11.2861L13.3356 11.2188L13.4204 11.3872Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2273 11.3872L13.3592 11.2861L13.3121 11.2188L13.2273 11.3872Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2273 11.3882L13.2744 11.2246L13.3545 11.2535L13.2273 11.3882Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3168 11.5898L13.2744 11.7198L13.3356 11.739L13.3168 11.5898Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3168 11.5898L13.3545 11.7198L13.2932 11.739L13.3168 11.5898Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4392 11.6855H13.3074V11.7529L13.4392 11.6855Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4392 11.6855L13.3356 11.7625L13.2932 11.7096L13.4392 11.6855Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1896 11.6855L13.2979 11.7625L13.3356 11.7096L13.1896 11.6855Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1896 11.6855H13.3215V11.7529L13.1896 11.6855Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3921 11.835L13.3545 11.7051L13.2885 11.7291L13.3921 11.835Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3921 11.8359L13.2885 11.7589L13.3262 11.7012L13.3921 11.8359Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2367 11.8359L13.345 11.7589L13.3074 11.7012L13.2367 11.8359Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2367 11.835L13.2791 11.7051L13.3403 11.7291L13.2367 11.835Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.783 10.7383L13.7406 10.8682L13.8065 10.8922L13.783 10.7383Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.783 10.7383L13.8253 10.8682L13.7594 10.8922L13.783 10.7383Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9101 10.834H13.7735V10.9013L13.9101 10.834Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9101 10.834L13.8018 10.911L13.7641 10.858L13.9101 10.834Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6558 10.834L13.7641 10.911L13.8018 10.858L13.6558 10.834Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6558 10.834H13.7877V10.9013L13.6558 10.834Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8583 10.9834L13.8206 10.8535L13.7547 10.8776L13.8583 10.9834Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8583 10.9843L13.7547 10.9073L13.7924 10.8496L13.8583 10.9843Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7029 10.9843L13.8112 10.9073L13.7735 10.8496L13.7029 10.9843Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7029 10.9834L13.7453 10.8535L13.8065 10.8776L13.7029 10.9834Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.155 10.4688L14.1032 10.6275L14.1832 10.6564L14.155 10.4688Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.155 10.4688L14.2068 10.6275L14.1267 10.6564L14.155 10.4688Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3104 10.584H14.1456V10.6706L14.3104 10.584Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3104 10.584L14.1785 10.685L14.1314 10.6177L14.3104 10.584Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 10.584L14.1314 10.685L14.1785 10.6177L13.9996 10.584Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 10.584H14.1644V10.6706L13.9996 10.584Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2539 10.7721L14.2021 10.6133L14.122 10.6373L14.2539 10.7721Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2539 10.7719L14.1173 10.6757L14.1691 10.6035L14.2539 10.7719Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0561 10.7719L14.1926 10.6757L14.1408 10.6035L14.0561 10.7719Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0561 10.7721L14.1079 10.6133L14.1879 10.6373L14.0561 10.7721Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3026 10.6465L13.2603 10.7764L13.3262 10.8005L13.3026 10.6465Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3027 10.6465L13.345 10.7764L13.2791 10.8005L13.3027 10.6465Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4298 10.7441H13.2979V10.8115L13.4298 10.7441Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4298 10.7441L13.3215 10.8259L13.2838 10.7682L13.4298 10.7441Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1755 10.7441L13.2838 10.8259L13.3215 10.7682L13.1755 10.7441Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1755 10.7441H13.3121V10.8115L13.1755 10.7441Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3827 10.8927L13.3403 10.7676L13.2791 10.7868L13.3827 10.8927Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3827 10.8916L13.2744 10.8146L13.3121 10.7617L13.3827 10.8916Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2273 10.8916L13.3309 10.8146L13.2932 10.7617L13.2273 10.8916Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2273 10.8927L13.265 10.7676L13.3309 10.7868L13.2273 10.8927Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23416 8.19727L9.18236 8.35604L9.26241 8.38491L9.23416 8.19727Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23416 8.19727L9.28595 8.35604L9.2059 8.38491L9.23416 8.19727Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38956 8.3125H9.22475V8.39911L9.38956 8.3125Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38955 8.3125L9.2577 8.41354L9.2059 8.34618L9.38955 8.3125Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07405 8.3125L9.21061 8.41354L9.2577 8.34618L9.07405 8.3125Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07405 8.3125H9.24357V8.39911L9.07405 8.3125Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32834 8.50539L9.28125 8.3418L9.2012 8.37067L9.32834 8.50539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32834 8.50629L9.19649 8.40525L9.24358 8.33789L9.32834 8.50629Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13527 8.50629L9.27183 8.40525L9.22003 8.33789L9.13527 8.50629Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13527 8.50539L9.18707 8.3418L9.26712 8.37067L9.13527 8.50539Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.262 7.79883L12.2196 7.92874L12.2855 7.94798L12.262 7.79883Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.262 7.79883L12.3044 7.92874L12.2384 7.94798L12.262 7.79883Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3891 7.89453H12.2573V7.96189L12.3891 7.89453Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3891 7.89453L12.2808 7.97151L12.2431 7.91859L12.3891 7.89453Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1348 7.89453L12.2431 7.97151L12.2808 7.91859L12.1348 7.89453Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1348 7.89453H12.2667V7.96189L12.1348 7.89453Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3373 8.04307L12.2997 7.91797L12.2384 7.93721L12.3373 8.04307Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3373 8.04488L12.2337 7.96789L12.2714 7.91016L12.3373 8.04488Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1866 8.04488L12.2902 7.96789L12.2526 7.91016L12.1866 8.04488Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1866 8.04307L12.2243 7.91797L12.2902 7.93721L12.1866 8.04307Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10.0977L10.9388 10.2901L11.033 10.3238L11 10.0977Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10.0977L11.0612 10.2901L10.967 10.3238L11 10.0977Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1884 10.2383H10.9906V10.3393L11.1884 10.2383Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1884 10.2383L11.0282 10.3586L10.9717 10.2768L11.1884 10.2383Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8116 10.2383L10.9717 10.3586L11.0283 10.2768L10.8116 10.2383Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8116 10.2383H11.0094V10.3393L10.8116 10.2383Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1177 10.4639L11.0565 10.2715L10.9623 10.3052L11.1177 10.4639Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1177 10.4638L10.9576 10.3483L11.0141 10.2617L11.1177 10.4638Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8823 10.4638L11.0424 10.3483L10.9859 10.2617L10.8823 10.4638Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8823 10.4639L10.9435 10.2715L11.0377 10.3052L10.8823 10.4639Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5368 9.18945L11.485 9.35304L11.5651 9.3771L11.5368 9.18945Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5368 9.18945L11.5886 9.35304L11.5086 9.3771L11.5368 9.18945Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6922 9.30859H11.5274V9.39039L11.6922 9.30859Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6922 9.30859L11.5604 9.40482L11.5086 9.33746L11.6922 9.30859Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3814 9.30859L11.5133 9.40482L11.5604 9.33746L11.3814 9.30859Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3814 9.30859H11.5462V9.39039L11.3814 9.30859Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6357 9.49667L11.5839 9.33789L11.5038 9.36195L11.6357 9.49667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6357 9.49653L11.4991 9.39549L11.5462 9.32812L11.6357 9.49653Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4379 9.49653L11.5745 9.39549L11.5227 9.32812L11.4379 9.49653Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4379 9.49667L11.4897 9.33789L11.5698 9.36195L11.4379 9.49667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.76562L10.9482 8.9244L11.0282 8.95327L11 8.76562Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.76562L11.0518 8.9244L10.9717 8.95327L11 8.76562Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1554 8.88086H10.9906V8.96747L11.1554 8.88086Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1554 8.88086L11.0235 8.9819L10.9765 8.91454L11.1554 8.88086Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8446 8.88086L10.9765 8.9819L11.0235 8.91454L10.8446 8.88086Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8446 8.88086H11.0094V8.96747L10.8446 8.88086Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0989 9.07375L11.0471 8.91016L10.967 8.93902L11.0989 9.07375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0989 9.07465L10.9623 8.97361L11.0141 8.90625L11.0989 9.07465Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9011 9.07465L11.0377 8.97361L10.9859 8.90625L10.9011 9.07465Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9011 9.07375L10.9529 8.91016L11.033 8.93902L10.9011 9.07375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5338 9.22266L10.4914 9.35257L10.5574 9.37662L10.5338 9.22266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5338 9.22266L10.5762 9.35257L10.5103 9.37662L10.5338 9.22266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.661 9.31836H10.5244V9.38572L10.661 9.31836Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.661 9.31836L10.5526 9.39534L10.5103 9.34242L10.661 9.31836Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4067 9.31836L10.515 9.39534L10.5527 9.34242L10.4067 9.31836Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4067 9.31836H10.5385V9.38572L10.4067 9.31836Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6092 9.46885L10.5715 9.34375L10.5056 9.363L10.6092 9.46885Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6092 9.46871L10.5056 9.39172L10.5432 9.33398L10.6092 9.46871Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4538 9.46871L10.5621 9.39172L10.5244 9.33398L10.4538 9.46871Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4538 9.46885L10.4961 9.34375L10.5574 9.363L10.4538 9.46885Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7646 9.59375L10.7363 9.68517L10.7834 9.6996L10.7646 9.59375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7646 9.59375L10.7975 9.68517L10.7504 9.6996L10.7646 9.59375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.854 9.66016H10.7598V9.70827L10.854 9.66016Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.854 9.66016L10.7787 9.71308L10.7504 9.67459L10.854 9.66016Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6751 9.66016L10.7551 9.71308L10.7787 9.67459L10.6751 9.66016Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6751 9.66016H10.7693V9.70827L10.6751 9.66016Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8211 9.7672L10.7928 9.67578L10.7457 9.69022L10.8211 9.7672Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8211 9.76615L10.7457 9.70841L10.774 9.66992L10.8211 9.76615Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7128 9.76615L10.7881 9.70841L10.7598 9.66992L10.7128 9.76615Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7128 9.7672L10.741 9.67578L10.7834 9.69022L10.7128 9.7672Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3891 11.1953L12.3373 11.3589L12.4174 11.383L12.3891 11.1953Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3891 11.1953L12.4409 11.3589L12.3609 11.383L12.3891 11.1953Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5445 11.3105H12.3797V11.3972L12.5445 11.3105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5445 11.3105L12.4127 11.4116L12.3609 11.3442L12.5445 11.3105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.229 11.3105L12.3656 11.4116L12.4127 11.3442L12.229 11.3105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.229 11.3105H12.3985V11.3972L12.229 11.3105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4833 11.5034L12.4362 11.3398L12.3562 11.3687L12.4833 11.5034Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4833 11.5043L12.3515 11.4033L12.3985 11.3359L12.4833 11.5043Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2902 11.5043L12.4268 11.4033L12.375 11.3359L12.2902 11.5043Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2902 11.5034L12.342 11.3398L12.4221 11.3687L12.2902 11.5034Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7847 10.8105L12.7423 10.9405L12.8082 10.9597L12.7847 10.8105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7847 10.8105L12.8271 10.9405L12.7658 10.9597L12.7847 10.8105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9118 10.9023H12.78V10.9745L12.9118 10.9023Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9118 10.9023L12.8035 10.9841L12.7658 10.9312L12.9118 10.9023Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6575 10.9023L12.7658 10.9841L12.8082 10.9312L12.6575 10.9023Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6575 10.9023H12.7941V10.9745L12.6575 10.9023Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8647 11.0557L12.8223 10.9258L12.7611 10.9498L12.8647 11.0557Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8647 11.0566L12.7564 10.9796L12.7941 10.9219L12.8647 11.0566Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7093 11.0566L12.8129 10.9796L12.7753 10.9219L12.7093 11.0566Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7093 11.0557L12.747 10.9258L12.8129 10.9498L12.7093 11.0557Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0218 10.6953L11.9794 10.8252L12.0454 10.8445L12.0218 10.6953Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0218 10.6953L12.0642 10.8252L11.9983 10.8445L12.0218 10.6953Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.149 10.791H12.0171V10.8536L12.149 10.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.149 10.791L12.0407 10.868L12.003 10.8103L12.149 10.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8947 10.791L12.003 10.868L12.0407 10.8103L11.8947 10.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8947 10.791H12.0265V10.8536L11.8947 10.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0972 10.9405L12.0595 10.8105L11.9936 10.8346L12.0972 10.9405Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0972 10.9414L11.9936 10.8596L12.0312 10.8066L12.0972 10.9414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9465 10.9414L12.0501 10.8596L12.0124 10.8066L11.9465 10.9414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9465 10.9405L11.9842 10.8105L12.0454 10.8346L11.9465 10.9405Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13998 10.4844L9.07877 10.6816L9.17294 10.7105L9.13998 10.4844Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13999 10.4844L9.2012 10.6816L9.10703 10.7105L9.13999 10.4844Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32834 10.627H9.13057V10.728L9.32834 10.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32834 10.627L9.16824 10.7424L9.10703 10.6606L9.32834 10.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95163 10.627L9.11173 10.7424L9.16824 10.6606L8.95163 10.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95163 10.627H9.1494V10.728L8.95163 10.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2577 10.8535L9.19177 10.6562L9.0976 10.6899L9.2577 10.8535Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25771 10.8544L9.0929 10.7341L9.15411 10.6523L9.25771 10.8544Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02226 10.8544L9.18237 10.7341L9.12586 10.6523L9.02226 10.8544Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02226 10.8535L9.08348 10.6562L9.17766 10.6899L9.02226 10.8535Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.8105L10.9812 11.8779L11.0094 11.8875L11 11.8105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.8105L11.0188 11.8779L10.9906 11.8875L11 11.8105Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0612 11.8594H10.9953V11.8931L11.0612 11.8594Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0612 11.8594L11.0094 11.8979L10.9906 11.8738L11.0612 11.8594Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9388 11.8594L10.9906 11.8979L11.0094 11.8738L10.9388 11.8594Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9388 11.8594H11.0047V11.8931L10.9388 11.8594Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0377 11.9356L11.0188 11.873L10.9859 11.8827L11.0377 11.9356Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0377 11.9365L10.9859 11.898L11.0047 11.8691L11.0377 11.9365Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9623 11.9365L11.0141 11.898L10.9953 11.8691L10.9623 11.9365Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9623 11.9356L10.9812 11.873L11.0141 11.8827L10.9623 11.9356Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7031_17369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 17,
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrazilValidation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brazil_validation.d7260928a4482206e181bba286e5a1c6.svg";